import { render, staticRenderFns } from "./DrugCategories.vue?vue&type=template&id=e06a08f2"
import script from "./DrugCategories.vue?vue&type=script&lang=js"
export * from "./DrugCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports